import EntityList from './EntityList';
export { EntityList };
export default EntityList;
